export const LAYOUT = {
  DETAILED: "detailed",
  COMPACT: "compact",
};
